import { StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class MixerAudioStreamAddCmd {
  private static validation = JsonSchemaValidator.compile(
    MixerAudioStreamAddCmd.validationSchema()
  );

  readonly value: MixerAudioStreamAdd;

  constructor(value: MixerAudioStreamAdd) {
    this.value = JsonSchemaValidator.assert(
      MixerAudioStreamAddCmd.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["streamId"],
      properties: {
        streamId
      },
      additionalProperties: false
    };
  }
}

interface MixerAudioStreamAdd {
  streamId: StreamId;
}
